var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_379_1614)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.0013,
    cy: 2.50016,
    rx: 7.66667,
    ry: 1.83333,
    transform: "rotate(-180 8.0013 2.50016)",
    fill: "black"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 2.16667,
    cy: 10.3335,
    rx: 5,
    ry: 1.83333,
    transform: "rotate(90 2.16667 10.3335)",
    fill: "black"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.9987,
    cy: 10.6667,
    rx: 4.66667,
    ry: 1.83333,
    transform: "rotate(90 7.9987 10.6667)",
    fill: "black"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 13.8346,
    cy: 10.3335,
    rx: 5,
    ry: 1.83333,
    transform: "rotate(90 13.8346 10.3335)",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_379_1614"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.7b1572b4e59227c8b584411dc5557599.svg";
export { ForwardRef as ReactComponent };